import React from 'react';
import { ConfigProvider, ThemeConfig } from 'antd';
import { useSelector } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import AppRouter from './routes/AppRouter';
import './App.scss';
import Header from './components/Header/Header';
import Sidebar from './components/Sidebar/Sidebar';
import keycloak from './hooks/keycloak';
import KeycloakAuthHandler from './pages/login/KeycloakAuthHandler';
import { retrieveData } from './common/CommonExport';


const config: ThemeConfig = {
    token: { colorPrimary: '#D34A7C' },
    components: {
        Button: {
            colorPrimary: '#D23B7D',
            algorithm: true,
        },
        Input: {
            colorPrimary: '#eb2f96',
            algorithm: true,
        },
    },
};

const App: React.FC = () => {
    // Subscribing to the token keeps App re-rendering on login/logout. Without it App
    // reads storage only once at mount, so the Header/Sidebar stay unmounted after a
    // fresh login until the page is refreshed.
    const token = useSelector((state: any) => state?.authToken?.token);
    const isLoggedIn = retrieveData('isLoggedIn', true);

    return (
        <div className="App bg-[#F5F6FF] min-h-[100vh]">
            <ConfigProvider theme={config}>
                <BrowserRouter>
                    {(keycloak.authenticated || isLoggedIn || token) && (
                        <>
                            <Header />
                            <Sidebar />
                            <KeycloakAuthHandler />
                        </>
                    )}
                    {/* Kept in a fixed child slot so flipping the condition above mounts the
                        chrome without remounting the router and the page currently on screen. */}
                    <AppRouter />
                </BrowserRouter>
            </ConfigProvider>
        </div>
    );
};

export default App;
